<section id="content">
  <form id="form">
    <div class="spinner-container">
      <div class="spinner">
        <div class="sk-folding-cube">
          <div class="sk-cube1 sk-cube"></div>
          <div class="sk-cube2 sk-cube"></div>
          <div class="sk-cube4 sk-cube"></div>
          <div class="sk-cube3 sk-cube"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 col-xs-12 table-cont" id="leads-table">
        <div class="card">
          <p-messages [escape]="true" [value]="msgs"></p-messages>
          <div class="card-title">
            <h2 style="margin-top: 10px; margin-bottom: 10px;">Opportunities</h2>

            <p-table>
              <ng-template pTemplate="caption">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <!-- Left buttons with labels -->
                  <div style="text-align: left;">
                    <p-multiSelect [ngModelOptions]="{standalone: true}" [options]="filteredColumns"
                      [(ngModel)]="selectedColumns" optionLabel="header" selectedItemsLabel="Choose Columns"
                      placeholder="Choose Columns" [style]="{'min-width': '200px'}" inputId="float-label"
                      (onChange)="onColumnSelect()">
                      <label for="float-label">Choose Columns:</label>
                    </p-multiSelect>

                    <!-- <div style="margin-bottom: 5px;">Export Data</div> -->
                    <!--                    
                    <button type="button" pButton icon="pi pi-file-excel" iconPos="left"
                            label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;"
                            class="ui-button-success"></button>
                    <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF"
                            (click)="exportPdf()" class="ui-button-warning"></button> -->
                  </div>

                  <!-- Right buttons with labels -->
                  <div style="text-align: left; margin-left: 60px;">
                    <!-- <div style="margin-bottom: 5px;">Export Report</div> -->
                    <!-- Label for right buttons -->


                    <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                      (click)="onDownloadExcelReport()" style="margin-right: 0.5em;" class="ui-button-success"></button>
                    <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF"
                      (click)="onDownloadPDFReport()" class="ui-button-warning"></button>


                  </div>
                </div>
              </ng-template>
            </p-table>


            <!--
            <div align="right" style="margin-top: -20px;margin-right:60px;">
                <button
                    style="cursor: pointer;background-color: gainsboro; margin-right: 4px; color: darkred;"
                    id="downloadPDFReport" pTooltip="Export PDF" tooltipPosition="top" type="submit"
                    value="downloadPDFReport" class="btn" (click)="onDownloadPDFReport()">
                    <i class="fa fa-file-pdf fa-lg"></i></button>

                <button style="cursor: pointer;background-color: gainsboro;  color: darkgreen;"
                    id="downloadExcelReport" pTooltip="Export Excel" tooltipPosition="top" type="submit"
                    value="downloadExcelReport" class="btn" (click)="onDownloadExcelReport()">
                    <i class="fa fa-file-excel fa-lg"></i></button>
            </div>


            <p-table>
                <ng-template pTemplate="caption">
                    <div class="ui-helper-clearfix" style="text-align: left">
                        <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                            (click)="exportExcel()" style="margin-right: 0.5em;"
                            class="ui-button-success"></button>
                        <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF"
                            (click)="exportPdf()" class="ui-button-warning"></button>
                    </div>


                </ng-template>
            </p-table> -->

          </div>
          <div class="cont">
            <div class="table-respnsive">
              <!-- Column Selection Dropdown -->



              <p-table #dt class="table" styleClass="ui-table-customers" tableStyleClass="table table-responsive"
                [value]="opportunityDataRows" [columns]="selectedColumns" totalRecords="{{opportunityDataRows.length}}"
                [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" rowHover="true"
                [paginator]="true" [resizableColumns]="true" [scrollable]="true" [autoLayout]="true"
                [reorderableColumns]="true" (onColReorder)="onColReorder($event)" [filters]="filters"
                stateKey="Filters" stateStorage="local" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                <ng-template pTemplate="header">
                  <tr>
                    <!-- Dynamically rendered selected columns -->

                    <ng-container *ngFor="let col of selectedColumns">
                      <th pReorderableColumn pSortableColumn="{{col.field}}" [style.width.%]="col.width">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                      </th>
                    </ng-container>

                    <!-- Always visible action columns -->
                    <th colspan="5" width="9%" alignFrozen="right" pFrozenColumn>Actions</th>
                  </tr>
                  <tr>
                    <!-- Column filters for each visible column -->
                    <ng-container *ngFor="let col of selectedColumns">
                      <th>
                        
                        <p-columnFilter *ngIf="col.filterType === 'text'" type="text" [field]="col.field" display="menu"
                          matchMode="contains">
                        </p-columnFilter>

                     




                        <p-columnFilter *ngIf="col.filterType === 'dropdown'" [field]="col.field" matchMode="in"
                          display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                          <ng-template pTemplate="header">
                            <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">Select The {{col.header}} </span>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">

                            <p-multiSelect [options]="col.options" optionLabel="label" optionValue="value"
                              [filter]="true" [showClear]="true"
                              (onChange)="filter($event.value, col.field, 'in')"
                            
                              placeholder="Any">

                              <ng-template let-option pTemplate="item">
                                <div class="inline-block vertical-align-middle">
                                  <span>{{ option.label }}</span>
                                </div>
                              </ng-template>

                            </p-multiSelect>

                          </ng-template>

                        </p-columnFilter>





                        <p-columnFilter *ngIf="col.filterType === 'numeric'" type="numeric" [field]="col.field"
                          display="menu" matchMode="equals">
                        </p-columnFilter>


                        <p-columnFilter *ngIf="col.filterType === 'date'" [field]="col.field" [type]="'date'"
                          display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                          matchMode="in" >

                          <ng-template pTemplate="header">
                            <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">Select Year</span>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [options]="yearOptions" optionLabel="label" optionValue="value"
                              [filter]="true" [showClear]="true" placeholder="Select Years"
                              (onChange)="filter($event.value, col.field, 'in')">
                            </p-multiSelect>
                          </ng-template>
                        </p-columnFilter>



                        <p-columnFilter *ngIf="col.filterType === 'quarter'" [field]="col.field" [type]="'date'"
                          display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                          matchMode="in">

                          <ng-template pTemplate="header">
                            <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">Select Quarter </span>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [options]="quarterOptions" optionLabel="label" optionValue="value"
                              [filter]="true" [showClear]="true" placeholder="Select Quarter"
                              (onChange)="filter($event.value, col.field, 'in')"
                              >
                            </p-multiSelect>
                          </ng-template>
                        </p-columnFilter>




                        <p-columnFilter *ngIf="col.filterType === 'month'" [field]="col.field" [type]="'date'"
                          display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                          matchMode="in">

                          <ng-template pTemplate="header">
                            <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">Select Month</span>
                            </div>
                          </ng-template>

                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-multiSelect [options]="monthOptions" optionLabel="label" optionValue="value"
                              [filter]="true" [showClear]="true" placeholder="Select Month"
                              (onChange)="filter($event.value, col.field, 'in') "
                              >
                            </p-multiSelect>
                          </ng-template>
                        </p-columnFilter>




                      </th>
                    </ng-container>
                    <th alignFrozen="right" pFrozenColumn
                      *ngIf="(authenticationService.cadenceRole.accessLevel || 0) >= accessLevelEnum.read_write"></th>
                    <th alignFrozen="right" pFrozenColumn></th>
                    <th alignFrozen="right" pFrozenColumn
                      *ngIf="(authenticationService.cadenceRole.accessLevel || 0) >= accessLevelEnum.read_write"></th>
                    <th alignFrozen="right" pFrozenColumn
                      *ngIf="(authenticationService.cadenceRole.accessLevel || 0) > accessLevelEnum.read_write"></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-opportunityrow>
                  <tr>
                    <!-- Dynamically rendered columns based on selection -->
                    <ng-container *ngFor="let col of selectedColumns">

                      <td *ngIf="col.field != 'status' && col.field != 'sector' && col.field !='creationDate' && !['sss', 'swg', 'stg', 'service'].includes(col.field)">
                        {{ opportunityrow[col.field] }}
                      </td>


                      <td *ngIf="col.field == 'status' ">
                        <span class="status" [class]="opportunityrow.statusClass" id="{{opportunityrow.statusId}}"
                          pTooltip="{{opportunityrow.statusClass}}" tooltipPosition="top">
                        </span>
                      </td>

                      
                      <td *ngIf="['sss', 'swg', 'stg', 'service'].includes(col.field)">
                        {{ opportunityrow[col.field] | number }}
                      </td>
                      
                      <td *ngIf="col.field == 'creationDate'">
                        {{ opportunityrow[col.field] | date:'MMM d, yyyy' }}
                       
                      </td>
                    


                      <td *ngIf="col.field == 'sector' ">
                        <span [class]="opportunityrow.sectorClass" pTooltip="{{opportunityrow.sector}}"
                          tooltipPosition="top">
                        </span>

                      </td>


                    </ng-container>

                    <!-- Always visible action columns -->
                    <td alignFrozen="right" pFrozenColumn>
                      <ul>
                        <li class="open"><i class="la la-external-link-alt" style="cursor: pointer;"
                            *ngIf="(authenticationService.cadenceRole.accessLevel || 0) >= accessLevelEnum.read_write"
                            (click)="selectData(opportunityrow.opportunityId)"></i></li>
                      </ul>
                    </td>
                    <td alignFrozen="right" pFrozenColumn>
                      <ul>
                        <li class="history"><i class="fa fa-history" style="cursor: pointer;"
                            (click)="showHistory(opportunityrow.opportunityId)"></i></li>
                      </ul>
                    </td>
                    <td alignFrozen="right" pFrozenColumn>
                      <ul
                        *ngIf="showEditBtn && opportunityrow.statusId <= 5 && (authenticationService.cadenceRole.accessLevel || 0) >= accessLevelEnum.read_write">
                        <li class="edit"><i class="fa fa-edit" style="cursor: pointer;"
                            (click)="editOpportunity(opportunityrow)"></i></li>
                      </ul>
                    </td>
                    <td alignFrozen="right" pFrozenColumn>
                      <ul
                        *ngIf="canDelete && (authenticationService.cadenceRole.accessLevel || 0) > accessLevelEnum.read_write">
                        <li class="delete text-red"><i class="la la-trash" style="cursor: pointer;"
                            (click)="onDeleteOpportunity(opportunityrow.opportunityId)"></i></li>
                      </ul>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

            </div>
          </div>
        </div>
      </div>

      <app-filter [displayProductKindCheckBoxes]="displayProductKindCheckBoxes" [filterForPage]="filterForPage"
        [sectors]="sectorList" [statusList]="statusList" [customerNameList]="customerNameList"
        [opportunityNameList]="opportunityNameList" (onResetClick)="onResetClick($event)"
        (onDropDownClicked)="onDropDownClicked($event)" (onCheckBoxClicked)="onCheckBoxClicked($event)"
        (filterClicked)="filterClicked($event)"></app-filter>

    </div>

  </form>
</section>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<p-dialog header="Close Opportunity" [(visible)]="displayEditDialog" [modal]="true" width="500" height="600"
  responsive="true" closeOnEscape="true">
  <close-opportunity [statusList]="statusList" [sectors]="sectorList" #closeOpportunity></close-opportunity>
</p-dialog>





<!-- Filter SSS Range Dialog -->
<!-- <p-dialog header="Filter SSS Range" [(visible)]="display_SSS_Dialog" [modal]="true" [closable]="true"
    [style]="{width: '200px'}">
    <div class="p-fluid p-grid p-jc-between" [id]="'filter-range-dialog'">
        <div class="p-col-6">
            <div class="p-field">
                <label for="from">From</label>
                <input pInputText id="from" type="number" [(ngModel)]="sssFilter.from"
                    [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="p-col-6">
            <div class="p-field">
                <label for="to">To</label>
                <input pInputText id="to" type="number" [(ngModel)]="sssFilter.to"
                    [ngModelOptions]="{standalone: true}">
            </div>
        </div>
        <div class="p-col-12 p-d-flex p-jc-end p-ai-center">
            <button pButton type="button" label="Reset" icon="pi pi-times" class="p-button-secondary p-mr-2"
                (click)="reset_SSS_Filter()"></button>
                &nbsp;&nbsp;
            <button pButton type="button" label="Apply" icon="pi pi-check" class="p-button-primary"
                (click)="applySSSRangeFilter()"></button>
        </div>
    </div>
</p-dialog> -->